import React from "react";
import { styled } from "@mui/system";
import MUIAvatar, { AvatarProps } from "@mui/material/Avatar";

export const Avatar = styled((props: AvatarProps) => <MUIAvatar {...props} />, {
  name: "Avatar",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiAvatar-root": {
    background: theme.palette.primary.background,
    color: theme.palette.primary.iconDefault,
  },
  "&.MuiAvatar-rounded": {
    borderRadius: "4px",
  },
}));
